"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var _Input = _interopRequireDefault(require("../../component/Input"));

var _Icon = _interopRequireDefault(require("../../component/Icon"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]); // eslint-disable-next-line complexity

var SearchInputWithButton = function SearchInputWithButton(_ref) {
  var className = _ref.className,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      placeholder = _ref.placeholder,
      clearInput = _ref.clearInput,
      kind = _ref.kind,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      clearSearchDataTestId = _ref.clearSearchDataTestId,
      performSearchDataTestId = _ref.performSearchDataTestId,
      searchInputDataTestId = _ref.searchInputDataTestId,
      onSearch = _ref.onSearch,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["className", "value", "placeholder", "clearInput", "kind", "disabled", "onChange", "clearSearchDataTestId", "performSearchDataTestId", "searchInputDataTestId", "onSearch"]);
  var classes = useStyles();

  var _React$useState = React.useState(value),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      internalValue = _React$useState2[0],
      setInternalValue = _React$useState2[1];

  React.useEffect(function () {
    setInternalValue(value);
  }, [value]);

  var handleChange = function handleChange(e) {
    if (!onSearch) onChange === null || onChange === void 0 ? void 0 : onChange(e);else setInternalValue(e.target.value);
  };

  var handleClearInput = function handleClearInput() {
    setInternalValue('');
    clearInput === null || clearInput === void 0 ? void 0 : clearInput();
  };

  var handleKeyPress = function handleKeyPress(e) {
    if (e.key === 'Enter' || e.key === 'Backspace' && internalValue === '') {
      onSearch === null || onSearch === void 0 ? void 0 : onSearch(internalValue);
    }
  };

  return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])(classes.SearchInput, className)
  }, rest), /*#__PURE__*/React.createElement(_Input["default"], {
    className: classes.Input,
    "data-input": "search-input",
    disabled: disabled,
    kind: kind,
    onChange: handleChange,
    placeholder: placeholder,
    value: internalValue,
    "data-test-id": searchInputDataTestId,
    onKeyUp: handleKeyPress
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.ButtonContainer
  }, internalValue && /*#__PURE__*/React.createElement("button", {
    className: (0, _classnames["default"])(classes.SearchClear),
    "data-test-id": clearSearchDataTestId,
    onClick: handleClearInput
  }, /*#__PURE__*/React.createElement(_Icon["default"], {
    glyph: "cross"
  })), onSearch && /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return onSearch(internalValue);
    },
    "data-test-id": performSearchDataTestId,
    className: (0, _classnames["default"])(classes.SearchButton, (0, _defineProperty2["default"])({}, 'active', !!internalValue))
  }, /*#__PURE__*/React.createElement(_Icon["default"], {
    glyph: "magnifying-glass",
    className: (0, _classnames["default"])(disabled && classes.Disabled)
  }))));
};

exports["default"] = SearchInputWithButton;
//# sourceMappingURL=index.js.map